<template>
  <div class="tasks-list">
    <header class="page-navs search-bar bg-light shadow-sm pl-3 pr-1 py-2">
      <div class="d-md-inline-block">
        <div class="input-group input-group-alt has-clearable">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"><span class="oi oi-magnifying-glass"></span></span>
            </div>
            <input type="text"
                   class="form-control"
                   id="search-tasks"
                   placeholder="Buscar tarea"
                   v-model="query"
                   @keyup="search">
          </div>
          <div class="input-group-append">
            <task-classifications @classification-selected="filterByClassification"></task-classifications>
          </div>
        </div>
      </div>
    </header>
    
    <div class="board p-0">
      <ul class="tasks-list list-group list-group-flush list-group-divider border-top w-100"
          v-if="(!loading && !loadingMore) && tasks.length">
        <li :key="task.id"
            :task="task"
            class="list-group-item"
            is="task-list-item"
            v-bind="$props"
            v-for="task in tasks"
            :data-id="task.id"
            @show-task="showTask"></li>
      </ul>
      
      <div v-if="(!loading && !loadingMore) && tasks.length === 0"
           class="d-flex flex-column justify-content-center align-items-center vh-100 ">
        <p><i class="far fa-list-alt fa-5x text-gray"></i></p>
        <p class="text-gray"> {{ this.query === null ? 'No existen tareas asignadas' : 'No se encontraron tareas' }}</p>
      </div>
      
      <div class="w-100 text-center mt-3" v-if="loading || loadingMore">
        <div class="spinner-border text-success" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    
    </div>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import TaskListItem from './TaskListItem'
  import TaskClassifications from './TaskClassifications'
  import Task from './Task'
  
  export default {
    name: 'TasksList',
    components: {
      Task,
      TaskListItem,
      TaskClassifications,
    },
    data () {
      return {
        loading: true,
        loadingMore: false,
        query: null,
        page: 1,
        currentTasks: [],
        currentPage: null,
      }
    },
    methods: {
      ...mapActions({
        getTasks: 'tasks/getTasks',
      }),
      
      ...mapMutations(['tasks/setTask']),
      
      async load (params = {}) {
        this.loading = true
        
        await this.getTasks(params)
        
        this.loading = false
      },
      showTask (task) {
        this.$emit('show-task', task)
  
        Looper.showSidebar()
      },
      async filterByClassification (classification) {
        await this.load({ classification: classification })
      },
      
      async search (e) {
        const key = e.keyCode
        
        if (key === 13) { // Enter.
          if (this.query.length) {
            this.loading = true
            
            await this.getTasks({ query: this.query })
            
            this.loading = false
            
            return
          }
        }
        
        if (key === 27) { // Esc.
          return this.clearSearch()
        }
      },
      
      async clearSearch () {
        this.query = null
        
        await this.load()
      },
    },
    computed: {
      ...mapGetters({
        tasks: 'tasks/tasks',
        task: 'tasks/selectedTask',
        classifications: 'tasks/classifications',
      }),
    },
    async mounted () {
      await this.load()
      
      // Show selected task if present.
      if (this.task) {
        this.$emit('show-task', this.task)
        
        // Mark task item as active.
        const item = document.querySelector(`.list-group-item[data-id="${this.task.id}"]`)
        if(item) {
          item.classList.add('active')
        }
        
        Looper.showSidebar()
      }
    },
    watch: {
      task() {
        if(this.task) {
          if(this.task.classification && this.task.classification.key !== 'protocolo_pendiente') {
             Looper.showSidebar()
          }
        }
      }
    },
  }
</script>
